import {Component, Injector, OnInit} from '@angular/core';
import {AbstractListOrmComponent} from "../../AbstractListOrmComponent";
import {Especime} from "../../../../domain/Especime";
import {FaunaDataSource} from "../../../../services/persist/FaunaDataSource";
import {Grupo} from "../../../../domain/enums";
import {TableLazyLoadEvent} from "primeng/table";
import {FindManyOptions} from "typeorm";

@Component({
  selector: 'app-list-pessoa',
  templateUrl: './list-especime.component.html',
  styleUrls: ['./list-especime.component.scss'],
})
export class ListEspecimeComponent extends AbstractListOrmComponent<Especime>{
  agenciavel = true
  urlEdicao = '/registro/especime';
  grupos = Object.values(Grupo)
  override relations = ['taxon','microRH','bioma','fitofisionomia','municipio']
  select = ['id','dataHora','taxon.grupo','taxon.name','taxon.commonNames','taxon.status','municipio.nome','bioma.nome','microRH.nome']
  constructor(injector: Injector, ds: FaunaDataSource) {
    super(injector,  ds.getRepository(Especime))
  }


  getStatusConservacao(array: any[]): String {
    if (array != undefined && array.length > 0) {
      let texto: String = ''
      array.forEach( a => {
        // console.log(a)
        for (const [key, value] of Object.entries(a)) {
          // console.log(`${key}: ${value}`);
          texto = texto + ' ' + key + ' : ' + value + ','
        }
      })
      return texto
    } else
      return ''
  }

}
